import templateUrl from './resourceViewHeader.html'

/**
 * Resource View page header component.
 *
 * @example
 * <tmr-resource-view-header
 *   resource="$ctrl.resource"
 *   resource-list-title="REPORT.ASNS.TITLE"
 *   resource-details="[
 *   { label: 'REPORT.ASNS.VIEW.ID', value: $ctrl.resource.id },
 *   { label: 'REPORT.ASNS.VIEW.CREATIONDATE', value: $ctrl.resource.creationDate, filter: 'tmrDate' }
 * ></tmr-resource-view-header>
 *
 * @type {ngComponent}
 * @prop {TmrResource} resource
 * @prop {string} resource-list-title
 * @prop {array} resource-details
 * @prop {array} drilldown
 */
export const tmrResourceViewHeader = {
  ngType: 'component',
  templateUrl,
  controller: 'tmrResourceViewHeaderController',
  bindings: {
    resource: '<',
    resourceListTitle: '@',
    resourceDetails: '<',
    resourceListSref: '<?',
    drilldown: '<?',
  },
}

/**
 * Controller of component {@link tmrResourceViewHeader}.
 *
 * @type {ngController}
 */
export class tmrResourceViewHeaderController {
  static ngType = 'controller'

  $onInit() {
    this.resourceListSref = this.resourceListSref || '^.list'
  }
}
